import { useSearchParams } from "react-router-dom";
import ReportVocEmissionTable from "./components/ReportVocEmissionTable";
import { useShallow } from "zustand/react/shallow";
import { profileStore } from "src/stores/profile-store";
import { useEffect } from "react";
import useGoBack from "src/hook/useGoBackInventory";
let isRequestCompany: string | null = null;

const OthersReport = () => {
  const [searchParams] = useSearchParams();
  const companyId = searchParams.get("companyId");
  const profile = profileStore(useShallow((state) => state.profile));
  const requestProfile = profileStore(useShallow((state) => state.requestProfile));
  useGoBack();
  useEffect(() => {
    if (profile?.company && profile.company.length > 0 && companyId && (!isRequestCompany || isRequestCompany != companyId)) {
      const findSlot = profile.company.find((item) => item._id == companyId);
      if (findSlot) {
        requestProfile({ companyId: companyId });
        isRequestCompany = companyId;
      } else {
        window.location.pathname = "/unauthorized";
      }
    }
  }, [profile?.company]);
  return <ReportVocEmissionTable />;
};

export default OthersReport;
// https://chem-voc-dev-ajgjcfczf2fhc5g4.a01.azurefd.net/vocs-inventory/others/report?companyId=66a32c0aa3d1da9e2e5efeaf&year=2025&month=feb&approveNo=1
// http://localhost:3000/vocs-inventory/others/report?companyId=66a32c0aa3d1da9e2e5efeaf&year=2025&month=feb&approveNo=1
